import { render, staticRenderFns } from "./ListOfWantedPersons.vue?vue&type=template&id=49732ab0&scoped=true&"
import script from "./ListOfWantedPersons.vue?vue&type=script&lang=js&"
export * from "./ListOfWantedPersons.vue?vue&type=script&lang=js&"
import style0 from "./ListOfWantedPersons.vue?vue&type=style&index=0&id=49732ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49732ab0",
  null
  
)

export default component.exports